import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import AccountList from '@app/views/Account/List';
import { memo } from 'react';

export default memo(
  withIfUser(AccountList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
